"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPage1Saga = fetchPage1Saga;
exports.fetchPage1SuccessSaga = fetchPage1SuccessSaga;
exports.fetchNextPageSaga = fetchNextPageSaga;
exports.pollPage1Saga = pollPage1Saga;
exports.pollPage1SuccessSaga = pollPage1SuccessSaga;
exports.fetchPrevPageSaga = fetchPrevPageSaga;
exports.scrollUpSaga = scrollUpSaga;
exports.scrollUpPage1SuccessSaga = scrollUpPage1SuccessSaga;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const effects_1 = require("redux-saga/effects");
const dayjs_1 = __importDefault(require("dayjs"));
const slice_1 = require("../slice");
const types_1 = require("../../ConfigProvider/types");
const saga_1 = require("../../ConfigProvider/saga");
const selectors_1 = require("../../LanguagesProvider/selectors");
const utils_1 = require("../../../utils");
const utils_2 = require("../../../api/events/utils");
const listsSelectors_1 = require("../selectors/listsSelectors");
const constants_1 = require("../constants");
function* buildRequest(listKey, _request) {
    const filters = yield (0, effects_1.select)(listsSelectors_1.getEventListFilters, listKey);
    const config = yield (0, effects_1.select)(listsSelectors_1.getListConfig, listKey);
    const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
    const includeSubsports = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const request = {
        locale,
        includeSubsports,
        ...config,
        ..._request,
        pageKey: undefined,
        ...filters,
    };
    // FIQL param must be provided by client
    // If we have met FIQL param, omit standard filters and returns request immediately
    // No need to run logic for search quety tokenization and others cpu comsuming features
    if (request.fiql) {
        return (0, utils_2.omitEventsRequestNonFiqlFilters)(request);
    }
    const tokenizeSearchQuery = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.TOKENIZE_SEARCH_QUERY_ENABLED);
    const searchQuery = tokenizeSearchQuery && filters.searchQuery
        ? (0, utils_1.tokenize)(filters.searchQuery)
        : filters.searchQuery;
    request.searchQuery = searchQuery;
    if (request.scheduledFromNow) {
        request.scheduledFrom = (0, dayjs_1.default)().format(constants_1.DATE_FORMAT);
    }
    if (request.scheduledToNow) {
        request.scheduledTo = (0, dayjs_1.default)().format(constants_1.DATE_FORMAT);
    }
    /*
      filters.period может быть числом, или строкой формата `${number}-days`.
  
      Когда число мы считаем, что дата начала равна текущему времени, а дата конца равна текущее время + filters.period часов.
      Пример использования: нужны события за ближайшие 2/3/6/12 часов.
  
      Когда filters.period является строкой, например 1-days, мы к текущему времени добавляем количество дней, и датой начала будет начало дня, а датой конца конец дня.
      Пример использования: нужны события за сегодня/завтра/послезавтра.
    */
    if (filters.period) {
        if (typeof filters.period === 'number') {
            request.scheduledFrom = (0, dayjs_1.default)().format(constants_1.DATE_FORMAT);
            request.scheduledTo = (0, dayjs_1.default)()
                .add(filters.period, 'hour')
                .format(constants_1.DATE_FORMAT);
            if (filters.period < 0) {
                // swap values
                const tmp = request.scheduledFrom;
                request.scheduledFrom = request.scheduledTo;
                request.scheduledTo = tmp;
            }
        }
        else {
            const daysCount = Number(filters.period.split('-')[0]);
            if (!Number.isNaN(daysCount)) {
                request.scheduledFrom = (0, dayjs_1.default)()
                    .add(daysCount, 'day')
                    .startOf('day')
                    .format(constants_1.DATE_FORMAT);
                request.scheduledTo = (0, dayjs_1.default)()
                    .add(daysCount, 'day')
                    .endOf('day')
                    .format(constants_1.DATE_FORMAT);
            }
        }
    }
    delete request.scheduledFromNow;
    delete request.scheduledToNow;
    return request;
}
function* fetchEventsSaga(request, sideEffects) {
    const includeSubsports = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEvents({
        reqData: request,
        sideEffects,
        params: {
            withCompetitorsLogo: false,
            withLinkedEvents: true,
            includeSubsports,
        },
    }));
}
function* fetchPage1Saga(action) {
    const request = yield (0, effects_1.call)(buildRequest, action.payload.listKey, action.payload.request);
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListPage1Success({
                ...payload,
                listKey: action.payload.listKey,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListError({
                ...payload,
                listKey: action.payload.listKey,
            });
        },
    });
}
/*
  1. Нет paginationKeyForward. Значит нет следующей страницы. Сохраняем только первую страницу.
  2. Есть paginationKeyForward. Значит есть следующая страница. Нужно сделать запрос на следующую страницу.
*/
function* fetchPage1SuccessSaga(action) {
    const { resData, reqData, listKey } = action.payload;
    if (!resData.paginationKeyForward) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchEventListSuccess({
            listKey,
            page1: {
                reqData,
                resData,
                pageNumber: 1,
            },
            page2: undefined,
        }));
        return;
    }
    const request = { ...reqData };
    request.pageKey = resData.paginationKeyForward;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Forward;
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListSuccess({
                listKey,
                page1: {
                    reqData,
                    resData,
                    pageNumber: 1,
                },
                page2: {
                    reqData: payload.reqData,
                    resData: payload.resData,
                    pageNumber: 2,
                },
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListError({
                ...payload,
                listKey: action.payload.listKey,
            });
        },
    });
}
function* fetchNextPageSaga(action) {
    const request = yield (0, effects_1.call)(buildRequest, action.payload.listKey, action.payload.request);
    const nextPageKey = yield (0, effects_1.select)(listsSelectors_1.getNextPageKey, action.payload.listKey);
    if (!nextPageKey)
        return;
    request.pageKey = nextPageKey;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Forward;
    const page1Number = yield (0, effects_1.select)(listsSelectors_1.getPage1Number, action.payload.listKey);
    const page2Number = yield (0, effects_1.select)(listsSelectors_1.getPage2Number, action.payload.listKey);
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListNextSuccess({
                ...payload,
                listKey: action.payload.listKey,
                page1Number,
                page2Number,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListNextError({
                ...payload,
                listKey: action.payload.listKey,
            });
        },
    });
}
function* pollPage1Saga(action) {
    const request = yield (0, effects_1.call)(buildRequest, action.payload.listKey, action.payload.request);
    const firstPage = yield (0, effects_1.select)(listsSelectors_1.getPage1, action.payload.listKey);
    request.pageKey = firstPage.paginationKey;
    request.pageKeyDirection = firstPage.paginationKeyDirection;
    const page1Number = yield (0, effects_1.select)(listsSelectors_1.getPage1Number, action.payload.listKey);
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.pollEventListPage1Success({
                ...payload,
                page1Number,
                page2Number: page1Number + 1,
                listKey: action.payload.listKey,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.pollEventListError({
                ...payload,
                listKey: action.payload.listKey,
            });
        },
    });
}
/*
  1. Нет paginationKeyForward. Значит нет следующей страницы. Сохраняем только первую страницу.
  2. Есть paginationKeyForward. Значит есть следующая страница. Нужно сделать запрос на следующую страницу.

  Если получили самую первую страницу (то есть нет paginationKeyBackward), но при этом есть reqData.pageKey, то нужно его сбросить.
*/
function* pollPage1SuccessSaga(action) {
    const { resData, page1Number, page2Number, listKey } = action.payload;
    let { reqData } = action.payload;
    // самая первая страница
    if (!resData.paginationKeyBackward) {
        reqData = { ...reqData, pageKey: undefined, pageKeyDirection: undefined };
    }
    if (!resData.paginationKeyForward) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.pollEventListSuccess({
            listKey,
            page1: {
                reqData,
                resData,
                pageNumber: page1Number,
            },
            page2: undefined,
        }));
        return;
    }
    const request = { ...reqData };
    request.pageKey = resData.paginationKeyForward;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Forward;
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.pollEventListSuccess({
                page1: {
                    reqData,
                    resData,
                    pageNumber: page1Number,
                },
                page2: {
                    reqData: payload.reqData,
                    resData: payload.resData,
                    pageNumber: page2Number,
                },
                listKey,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.pollEventListError({
                ...payload,
                listKey,
            });
        },
    });
}
function* fetchPrevPageSaga(action) {
    const request = yield (0, effects_1.call)(buildRequest, action.payload.listKey, action.payload.request);
    const prevPageKey = yield (0, effects_1.select)(listsSelectors_1.getPrevPageKey, action.payload.listKey);
    if (!prevPageKey)
        return;
    request.pageKey = prevPageKey;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Backward;
    const page1Number = yield (0, effects_1.select)(listsSelectors_1.getPage1Number, action.payload.listKey);
    const page2Number = yield (0, effects_1.select)(listsSelectors_1.getPage2Number, action.payload.listKey);
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            if (!payload.resData.paginationKeyBackward) {
                return slice_1.eventsProviderActions.fetchEventListPrevPageSuccess({
                    ...payload,
                    reqData: {
                        ...payload.reqData,
                        pageKey: undefined,
                        pageKeyDirection: betweb_openapi_axios_1.PaginationKeyDirection.Forward,
                    },
                    listKey: action.payload.listKey,
                    page1Number,
                    page2Number,
                });
            }
            return slice_1.eventsProviderActions.fetchEventListPrevPageSuccess({
                ...payload,
                listKey: action.payload.listKey,
                page1Number,
                page2Number,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.fetchEventListPrevPageError({
                ...payload,
                listKey: action.payload.listKey,
            });
        },
    });
}
function* scrollUpSaga(action) {
    const { listKey, pageNumber } = action.payload;
    const inactivePages = yield (0, effects_1.select)(listsSelectors_1.getInactivePages, listKey);
    const page = inactivePages[pageNumber];
    if (!page) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.resetListLoading({
            listKey,
        }));
        return;
    }
    const request = yield (0, effects_1.call)(buildRequest, listKey, action.payload.request);
    request.pageKey = page.paginationKey;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Forward;
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.scrollUpPage1Success({
                ...payload,
                page1Number: pageNumber,
                page2Number: pageNumber + 1,
                listKey,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.scrollUpError({
                ...payload,
                listKey,
            });
        },
    });
}
function* scrollUpPage1SuccessSaga(action) {
    const { resData, listKey } = action.payload;
    let { page1Number, page2Number, reqData } = action.payload;
    // самая первая страница
    if (!resData.paginationKeyBackward) {
        page1Number = 0;
        page2Number = 1;
        reqData = { ...reqData, pageKey: undefined, pageKeyDirection: undefined };
    }
    if (!resData.paginationKeyForward) {
        yield (0, effects_1.put)(slice_1.eventsProviderActions.scrollUpSuccess({
            listKey,
            page1: {
                reqData,
                resData,
                pageNumber: page1Number,
            },
            page2: undefined,
        }));
        return;
    }
    const request = { ...reqData };
    request.pageKey = resData.paginationKeyForward;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Forward;
    yield (0, effects_1.call)(fetchEventsSaga, request, {
        onSuccess: (payload) => {
            return slice_1.eventsProviderActions.scrollUpSuccess({
                page1: {
                    reqData,
                    resData,
                    pageNumber: page1Number,
                },
                page2: {
                    reqData: payload.reqData,
                    resData: payload.resData,
                    pageNumber: page2Number,
                },
                listKey,
            });
        },
        onError: (payload) => {
            return slice_1.eventsProviderActions.scrollUpError({
                ...payload,
                listKey,
            });
        },
    });
}
//# sourceMappingURL=listsSaga.js.map